import React, { Component } from "react";
import { Spin } from "antd";
import Swal from "sweetalert2";
import "../ORDER/OrderMaster/style.css";
import "antd/dist/antd.css";

export default class frmImageMetadataGenerator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      folderLink: "",
      loading: false,
      selectedCategory: "",
      uploadFile: null,
      jobId: null,
      mode: "mini", // ✅ Added mode (default full)
    };

    this.pollInterval = null;
  }

  handleChange = (e) => {
    this.setState({ folderLink: e.target.value });
  };

  handleCategoryChange = (e) => {
    this.setState({ selectedCategory: e.target.value });
  };

  handleFileUpload = (e) => {
    this.setState({ uploadFile: e.target.files[0] });
  };

  /* ================= POLLING STATUS API ================= */
  pollStatus = (jobId, token) => {
    this.pollInterval = setInterval(async () => {
      try {
        const response = await fetch(
          `https://api.blumangoes.ai:6143/job-status/${jobId}?db=IMAGEDB`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await response.json();

        const status =
          data.status ||
          data.job_status ||
          data.state ||
          (data.data && data.data.status);

        console.log("STATUS:", status);

        if (!status) return;

        if (status.toLowerCase() === "completed") {
          clearInterval(this.pollInterval);
          this.downloadExcel(jobId, token);
        }

        if (status.toLowerCase() === "failed") {
          clearInterval(this.pollInterval);
          this.setState({ loading: false });
          Swal.fire("Error", "Processing failed", "error");
        }
      } catch (err) {
        console.log("Polling error:", err.message);
      }
    }, 5000);
  };

  /* ================= DOWNLOAD EXCEL ================= */
  downloadExcel = async (jobId, token) => {
    try {
      const response = await fetch(
        `https://api.blumangoes.ai:6143/download/${jobId}?db=IMAGEDB`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "image_metadata_fields.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();

      this.setState({ loading: false });

      Swal.fire({
        icon: "success",
        title: "Metadata Generated",
        text: "Mini version file downloaded successfully.",
      });
    } catch (err) {
      this.setState({ loading: false });
      Swal.fire("Error", "Download failed", "error");
    }
  };

  /* ================= FIRST API CALL ================= */
  getExcelData = async () => {
    const token = localStorage.getItem("authToken1");

    if (!token) {
      Swal.fire("Unauthorized", "Please login again", "error");
      return;
    }

    if (!this.state.folderLink) {
      Swal.fire("Warning", "Please enter folder link", "warning");
      return;
    }

    if (!this.state.selectedCategory) {
      Swal.fire("Warning", "Please select category", "warning");
      return;
    }

    try {
      this.setState({ loading: true });

      const formData = new FormData();
      formData.append("folder_id", this.state.folderLink);
      formData.append("category", this.state.selectedCategory);
      formData.append("mode", this.state.mode); // ✅ ADDED (important)

      if (this.state.uploadFile) {
        formData.append("uploadFile", this.state.uploadFile);
      }

      const response = await fetch(
        "https://api.blumangoes.ai:6143/process-drive-folder?db=IMAGEDB",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "API error");
      }

      const jobId = data.job_id;

      if (!jobId) {
        throw new Error("Job ID missing");
      }

      this.setState({ jobId });

      this.pollStatus(jobId, token);
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
      Swal.fire("Error", error.message, "error");
    }
  };

  render() {
    return (
      <div className="content-wrapper">
        {this.state.loading && (
          <div className="loader">
            <div className="loader-item" style={{ marginLeft: "75vh" }}>
              <Spin tip="Generating metadata, please wait..." />
            </div>
          </div>
        )}

        <section className="content">
          <div className="box box-success" style={{ marginTop: "-13px" }}>
            <div className="box-header with-border" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '12px 20px' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 11, color: '#aaa', marginBottom: 3 }}>
                  Dashboard &gt; Image Tools &gt; Image Metadata Generator
                </div>
                <h3 className="box-title" style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>
                  Image Metadata Generator
                </h3>
              </div>
              <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 4, flexWrap: 'wrap' }}>
              </div>
            </div>

            <div className="box-body">
              <div className="row">
                <div className="col-xs-12 col-sm-6 col-md-6 margintop">
                  <label>Enter Folder Link *</label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.folderLink}
                    onChange={this.handleChange}
                  />
                </div>

                <div className="col-xs-12 col-sm-4 col-md-4 margintop">
                  <label>File Category *</label>
                  <select
                    className="form-control"
                    value={this.state.selectedCategory}
                    onChange={this.handleCategoryChange}
                  >
                    <option value="">--Select Category--</option>
                    <option value="footwear">Footwear</option>
                    <option value="apparel">Apparel</option>
                    <option value="accessories">Accessories</option>
                  </select>
                </div>

                <div className="col-xs-12 col-sm-4 col-md-4 margintop">
                  <label>Upload File</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={this.handleFileUpload}
                  />
                </div>

                <div className="col-xs-12" style={{ marginTop: "30px" }}>
                  <div className="text-center">
                    <button
                      className="btn btn-primary btn-lg"
                      onClick={this.getExcelData}
                      disabled={this.state.loading}
                    >
                      GENERATE METADATA
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}